<template>
  <div class="public-user-header-container">
    <router-link class="item" :class="pageKey == 'user' ? 'active' : ''" :to="{ path: '/user' }">个人信息</router-link>
    <router-link class="item" :class="pageKey == 'collection' ? 'active' : ''" :to="{ path: '/collection' }">我的收藏</router-link>
    <router-link class="item" :class="pageKey == 'order' ? 'active' : ''" :to="{ path: '/order' }">我的订单</router-link>
    <router-link class="item" :class="pageKey == 'people' ? 'active' : ''" :to="{ path: '/people' }">我的推广</router-link>
  </div>
</template>

<script>

export default {
  name: 'PcUserHeader',
  props: {
    pageKey: String
  },
  data() {
    return {
      
    }
  },
  mounted() {

  },
  methods: {
    
  }
}
</script>

<style scoped lang="less">
.public-user-header-container {
  width: 100%;
  height: 64px;
  border-radius: 8px 8px 0 0;
  background-color: #fafbff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .item {
    cursor: pointer;
    width: 124px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px 8px 0 0;
    margin-right: 30px;
    font-size: 16px;
    color: #3d3d42;
    &.active,
    &:hover {
      font-weight: bold;
      color: #6a5ffe;
      background-color: #fff;
      box-shadow: 4px -4px 12px 0 rgba(0, 0, 0, .06);
    }
  }
}
</style>
